export default function SetBodyColor({ color, secondaryColor }) {
    document.documentElement.style.setProperty("--bodyColor", color);
    document.documentElement.style.setProperty("--secondaryColor", secondaryColor);
}